import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const headerData = [
  {
    id: "branchName",
    numeric: false,
    disablePadding: true,
    label: "branchName",
  },
];

const diplayRows = ["date_and_month", "company_detail"];

function RecentSuppliers({ tableData, isLoading }) {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <Template
      primaryHeading={t("allNewSuppliers")}
      secondaryHeading={t("latest")}
    >
      {tableData?.length > 0 ? (
        <DashboardTable
          headerData={headerData}
          diplayRows={diplayRows}
          tableData={tableData}
        />
      ) : isLoading === false && tableData?.length === 0 ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound", { ns: "common" })}
          </Typography>
        </Stack>
      ) : null}
    </Template>
  );
}

export default RecentSuppliers;
